module.exports = __webpack_public_path__ + "img/other.15a9c022.svg";